import { isCustomerAdmin } from "./helpers";
const apiToolPermissions = {
    "api-tools": {
        index: ({ user, customer }) => isCustomerAdmin(user, customer),
        edit: ({ user, customer }) => isCustomerAdmin(user, customer),
        show: ({ user, customer }) => isCustomerAdmin(user, customer),
        new: ({ user, customer }) => isCustomerAdmin(user, customer),
        delete: ({ user, customer }) => isCustomerAdmin(user, customer),
    },
};
export default apiToolPermissions;
